// config

import BaseAnalyticsService from '../../common/BaseAnalyticsService';

const AnalyticsService = new BaseAnalyticsService();

export default AnalyticsService;
